import { Fragment } from 'react';

import { useQuery } from '@apollo/client/react';
import {
  Paper,
  Typography,
  List,
  ListItemButton,
  Divider,
  Skeleton,
} from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { useItems } from '@scorenco/components';
import { RouteLink, SsrQueryArgs } from '@scorenco/core';

import { RouteKey } from '@/routes';

import { GetDepartmentsDocument } from './Clubs.query.generated';

type DepartmentListProps = BoxProps & {
  sportSlug: string;
};

export const DepartmentList = ({ sportSlug, ...rest }: DepartmentListProps) => {
  const departmentsQuery = useQuery(GetDepartmentsDocument, {
    context: {
      role: 'anonymous',
    },
  });
  const departments = useItems(departmentsQuery.data?.places_department, 98);

  return (
    <Box {...rest}>
      <Typography
        variant="h5"
        sx={{ textTransform: 'uppercase', fontStyle: 'unset', mb: 2 }}
      >
        Départements
      </Typography>

      <Paper variant="bordered" sx={{ padding: 0, alignItems: 'stretch' }}>
        <List disablePadding>
          {departments.map((department, idx) => (
            <Fragment key={department?.id || idx}>
              {idx !== 0 && <Divider />}
              <ListItemButton
                component={RouteLink}
                href={{
                  routeKey: RouteKey.Clubs,
                  params: {
                    sport: sportSlug,
                    department: `${department?.code}`,
                  },
                }}
              >
                {department ? (
                  `${department.code} - ${department.name}`
                ) : (
                  <Skeleton width={200} />
                )}
              </ListItemButton>
            </Fragment>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

DepartmentList.ssrQuery = async ({ apolloClient }: SsrQueryArgs) =>
  await apolloClient.query({
    query: GetDepartmentsDocument,
  });
